import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'//React routes//GifLoader
import {
    Typography,
    Grid,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box, styled, useTheme
} from '@mui/material'//Se importan elementos de la librería material-ui
import Lottie from 'lottie-web-react'
//Custom components
import {
    ListElement,
    UseImage,
    GenericContainer,
    Buttons
} from '../../components'
import { fileActions, workflowActions, addTitleLegoCurrent } from '../../store/actions'//Acciones para redux
// import { mainStyles, theme } from '../../styles'//Estílos genéricos
import { useStyles } from './SummaryFormStyles'//Estílos específicos de los elementos de este componente
import { ClearSession, coreFunctions } from '../../utils'//funciones del nucleo
import fullfolderImg from '../../assets/fullfolder.svg'
import fullfolderPTImg from '../../assets/fullfolder_pt.gif'
// import fileOrangeImg from 'assets/file_orange.gif';
import fileOrangeImg from 'assets/fileOrange.gif';
import { useTranslation } from 'react-i18next';
import CancelarSolicitud from '../../assets/CancelarSolicitud.png'
import { persistence } from '../../store/persistence'

export default function SummaryFormComponent(props) {
    const { useState, useEffect } = React//Hook para el state
    const theme = useTheme()
    const location = useLocation()
    const classes = {} //mainStyles.bodyStyles()//estílos genéricos (Main.js)    
    const gridContainer = {} //mainStyles.gridStyle()
    const localStyles = useStyles()//estílos de este componente (LoginStyles.js)
    const navigate = useNavigate()//Módulo "History" de react router
    let interval = null;

    const [currentStage, setCurrentStage] = useState(0)
    const [stageProps, setStageProps] = useState(0)
    const [totalStage, setTotalStage] = useState(0)
    const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader    
    const [activeFind, setActiveFind] = useState(false)
    const [activeFileInfo, setActiveFileInfo] = useState(false)
    const [openBinncle, setOpenBinnacle] = useState(false)
    // const [binnacle, setBinnacle] = useState([])
    let idUser = sessionStorage.getItem('IdUserData')
    let UserFullName = sessionStorage.getItem('UserFullName')
    let UserDate = sessionStorage.getItem('UserDate')
    let FileCodeData = sessionStorage.getItem('FileCodeData')
    console.log('idUser', idUser)

    const [timerSeconds, setTimerSeconds] = useState(10)
    const [folioId, setFolioId] = useState(0)

    //Estados de componente
    const [fullName, setFullName] = useState('')
    const [fileCode, setFileCode] = useState('')
    const [fileDate, setFileDate] = useState('')
    const [stageDescription, setDescription] = useState('')
    // const [titleText, setTitleText] = useState('Información de la solicitud')
    // const [descText, setDescText] = useState('')
    // const [performLogout, setPerformLogout] = useState(0)

    //Redux hooks
    const auth = useSelector(state => state.Authentication)
    const wf = useSelector(state => state.Workflow)
    const file = useSelector(state => state.FileInfo)
    // const binnacleData = useSelector(state => state.Binnacle)
    // const notification = useSelector(state => state.ReSendNip)
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language || "es";

    console.log('StateActual', file.items)

    useEffect(() => {
        dispatch(addTitleLegoCurrent(t("info_solicitud_title")))
        let stageActual = location.state?.stage
        // setFullName(file.items.FullName)
        setDescription(stageActual?.Description)
        // setFileDate(file.items.CreationDate)
        // setFileCode(file.items.Folio)
        setCurrentStage(stageActual?.CurrentStageGroup)
        setTotalStage(stageActual?.TotalStageGroups)
        setFolioId(location.state?.folioId)
        console.log('props location', location.state)
        console.log('props location state', location.state)
        dispatch(fileActions.GetFileInfo(idUser ? idUser : location.state?.folioId))
        // const binnacleBody = {
        //     File_Id: location.state?.folioId,
        //     Actor_Id: location.state.folioId
        // }

        // dispatch(workflowActions.GetBinnacle(binnacleBody))
        setActiveFileInfo(true)
        console.log('props Id', location.state?.folioId)
    }, [])

    // useEffect(() => {
    //     if (binnacleData.items != undefined) {
    //         setBinnacle(binnacleData.items)
    //     }
    // }, [binnacleData])


    useEffect(() => {
        if (stageDescription == "Finalizado Aprobado" || stageDescription == "Finalizado"
            || stageDescription == "Finalizado Rechazado" || stageDescription == "Finalizado Cancelado") {
            setTimerSeconds(-10)
            console.log("**********Desactiva la variable de reload con version**********")
            localStorage.setItem('versionApp', "0");
        }
    }, [stageDescription])

    useEffect(() => {
        if (timerSeconds == 0) {
            //Realiza la peticion
            dispatch(fileActions.GetFileInfo(idUser ? idUser : folioId))
            setActiveFind(true)
        }
        // salir cuando lleguemos a 0
        if (!timerSeconds) return;

        // save intervalId para borrar el intervalo cuando el componente vuelve a renderizar
        const intervalId = setInterval(() => {
            setTimerSeconds(timerSeconds - 1);
        }, 1000);

        // clear interval al volver a renderizar para evitar pérdidas de memoria
        return () => clearInterval(intervalId);
    }, [timerSeconds]);

    useEffect(() => {
        setLoadView(file.loading)
        if (file.items != undefined && activeFileInfo) {
            console.log("StateActual 0", file?.items?.Stage?.Name)
            let performLogout = file.items.Stage.Properties.find(element => element.Name == "PerformLogout")
            console.log("StateActual 1", performLogout)
            // setPerformLogout(performLogout.Value)
            setFullName(file.items.FullName)
            setDescription(file.items.Stage.Description)
            setFileDate(file.items.CreationDateFormatted)
            setFileCode(file.items.Folio)
            setCurrentStage(file.items.Stage.CurrentStageGroup)
            setTotalStage(file.items.Stage.TotalStageGroups)
            console.log('FileInfo', file.items)
            let nextStage = file.items.Stage
            let stageName = nextStage.Name
            let stageId = nextStage.Id
            let stage = file.items
            let folioId = file.items.Id
            setTimerSeconds(8)
            console.log('activeFind', activeFind)
            console.log('activeFind', performLogout)
            if (activeFind) {
                const shouldLogout = performLogout !== null && performLogout !== undefined && performLogout?.Value == '1';
                const notAssigned = !file?.items?.IsAssignedUser

                // if (performLogout !== null && performLogout !== undefined && performLogout?.Value == '1' && file?.items?.Stage?.Name != "Información de la Solicitud") <-- condicion original
                if ((shouldLogout && file?.items?.Stage?.Name != "Información de la Solicitud") || notAssigned) {
                    console.log("PerformLogout REDIRECCION")
                    navigate('/auth/')
                    return
                } else {
                    let nextComponent = coreFunctions.GetLegoNext(stageName)
                    coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })

                    // const interval = setInterval(() => {
                    //     dispatch(fileActions.GetFileInfo(location.state.folioId))
                    //     setActiveFind(true)
                    // }, 20000);
                    // return () => clearInterval(interval);
                }
            }
            let title = file.items.Stage.Properties.find(element => element.Name == "TitleData")
            // let description = file.items.Stage.Properties.find(element => element.Name == "TextData")
            // setTitleText(title?.Value)
            dispatch(addTitleLegoCurrent(title?.Value))


            // setDescText(description?.Value)

            // else {
            //     const interval = setInterval(() => {
            //         dispatch(fileActions.GetFileInfo(location.state.folioId))
            //         setActiveFind(true)
            //     }, 20000);
            //     return () => clearInterval(interval);
            // }
        }
    }, [file]);

    //BinnacleTable: 
    // const columns = [
    //     { id: 'proceso', label: 'Proceso', width: "250px" },
    //     { id: 'fecha', label: 'Fecha y Hora', width: "150px" },
    // ]

    // const createData = (proceso, fecha) => {
    //     return { proceso, fecha }
    // }

    // const rows = binnacle.map((row) => {
    //     // let finalDate = SummaryFormFunctions.getDateHour(row.CreationDate)
    //     return createData(row.FlowState, row.CreationDateFormatted)
    // })

    // let watchAnimationData = require('../../assets/Loader.json')
    // const renderer = 'svg'
    // const rendererSettings = {
    //     preserveAspectRatio: 'xMinYMin slice',
    //     width: '30%',
    //     //   className: localStyles.lottieImgColor,  
    // }

    useEffect(() => {
        if (file.items?.Stage?.Name === "Ejecución paralela") {
            console.log('entraaqui a reload')
            let userIdData = idUser ? idUser : (location?.state?.folioId || file?.items?.Id)
            dispatch(fileActions.GetFileInfo(userIdData))
            setTimeout(() => {
                window.location.reload()
            }, 10000);
        }
    }, [file.items])



    return (<GenericContainer>
        {console.log('stageDescription', stageDescription)}
        {stageDescription == "Finalizado Rechazado" || stageDescription == "Finalizado Cancelado" ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 3, alignItems: 'center' }}>
                <Typography variant='h6'>
                    {t("procedure_cancelled")}
                </Typography>
            </Box>
        ) : null}
        <div className={localStyles.centerContentInfoMessage} >
            {stageDescription == "Finalizado Aprobado"
                ? <UseImage className={localStyles.topImage1}
                    src={fullfolderImg} />
                : stageDescription == "Finalizado Rechazado" || stageDescription == "Finalizado Cancelado" ?
                    <UseImage width={'60%'}
                        src={CancelarSolicitud} />
                    : <UseImage className={localStyles.topImage}
                        src={currentLanguage === "pt" ? fullfolderPTImg : fileOrangeImg} />}
        </div>
        <Typography variant="subtitle1" gutterBottom className={localStyles.title}>{t("info_message_applicant")}:</Typography>
        <Typography variant="subtitle1" gutterBottom  >{UserFullName ? UserFullName : fullName}</Typography>
        <div className={localStyles.containerResult}>
            <div className={localStyles.leftColumnResult}>
                <Typography variant="subtitle1" gutterBottom className={localStyles.title2}>{t("general_folio")}:</Typography>
                <Typography variant="subtitle1" gutterBottom  >{FileCodeData ? FileCodeData : fileCode}</Typography>
            </div>
            <div className={localStyles.rightColumnResult}>
                <Typography variant="subtitle1" gutterBottom className={localStyles.title2}>{t("info_message_create")}:</Typography>
                <Typography variant="subtitle1" gutterBottom  >{UserDate ? UserDate : fileDate}</Typography>
            </div>

        </div>
        {stageDescription == "Finalizado Rechazado" || stageDescription == "Finalizado Cancelado" ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, alignItems: 'center' }}>
                <Buttons
                    onClickConfirm={() => {
                        persistence.EndSession();
                        ClearSession();
                        navigate("/auth/");
                    }}
                    ConfirmButtonText="Finalizar"
                />
            </Box>
        ) : null}
        <div style={{ display: 'none' }} className={localStyles.centerContentInfoMessage} >

            {stageDescription == "Finalizado Aprobado" || stageDescription == "Finalizado" || stageDescription == "Finalizado Rechazado"
                ? <Button
                    className={gridContainer.buttonList}
                    // key={'btn_key_docs'}
                    onClick={() => {
                        navigate('/main/DocListComponent')
                    }}
                >
                    <ListElement
                        // key={'list_element_key_docs'}
                        text='Documentación' />
                </Button>
                : null
            }
        </div>
    </GenericContainer>)
}
